import LegalShell, { Section } from "@/components/LegalShell";

export default function Agb() {
  return (
    <LegalShell testId="agb-page" eyebrow="Rechtliches" title="Allgemeine Geschäftsbedingungen" updated="Januar 2026">
      <Section title="1. Geltungsbereich">
        <p>
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der App und Website
          „FestivalPlan", bereitgestellt von Sebastian Menzel (nachfolgend „Anbieter"). Mit der
          Registrierung bzw. Nutzung erkennst du diese Bedingungen an.
        </p>
      </Section>

      <Section title="2. Leistungsbeschreibung">
        <p>
          FestivalPlan ist eine Anwendung zur gemeinschaftlichen Organisation von Festivalbesuchen.
          Zu den Funktionen zählen unter anderem Gruppen, Gruppenchat, Packlisten, Aufgaben,
          Fahrgemeinschaften und eine Gruppenkasse. Der Anbieter ist bemüht, den Dienst dauerhaft
          verfügbar zu halten, übernimmt jedoch keine Gewähr für eine ununterbrochene Verfügbarkeit.
        </p>
      </Section>

      <Section title="3. Registrierung und Konto">
        <p>
          Für die Nutzung ist die Anlage eines Benutzerkontos erforderlich. Du bist verpflichtet,
          wahrheitsgemäße Angaben zu machen und deine Zugangsdaten vertraulich zu behandeln. Du bist
          für alle Aktivitäten verantwortlich, die über dein Konto erfolgen.
        </p>
      </Section>

      <Section title="4. Pflichten der Nutzer">
        <p>
          Du verpflichtest dich, keine rechtswidrigen, beleidigenden oder rechteverletzenden Inhalte
          über den Dienst zu verbreiten. Der Anbieter behält sich vor, Inhalte zu entfernen und Konten
          bei Verstößen zu sperren.
        </p>
      </Section>

      <Section title="5. Kosten">
        <p>
          Die Kernfunktionen von FestivalPlan werden derzeit kostenlos bereitgestellt. Der Anbieter
          behält sich vor, künftig kostenpflichtige Zusatzfunktionen einzuführen. Auf etwaige Kosten
          wird vor deren Nutzung ausdrücklich hingewiesen.
        </p>
      </Section>

      <Section title="6. Haftung">
        <p>
          Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie nach Maßgabe
          des Produkthaftungsgesetzes. Für leichte Fahrlässigkeit haftet der Anbieter nur bei
          Verletzung wesentlicher Vertragspflichten und begrenzt auf den vorhersehbaren, typischen
          Schaden.
        </p>
      </Section>

      <Section title="7. Kündigung">
        <p>
          Du kannst dein Konto jederzeit löschen. Der Anbieter kann das Nutzungsverhältnis unter
          Einhaltung einer angemessenen Frist beenden; das Recht zur außerordentlichen Kündigung aus
          wichtigem Grund bleibt unberührt.
        </p>
      </Section>

      <Section title="8. Schlussbestimmungen">
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB
          unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Bei Fragen
          erreichst du uns unter{" "}
          <a href="mailto:info@festivalplan.app" className="text-[#00E5FF]">info@festivalplan.app</a>.
        </p>
      </Section>
    </LegalShell>
  );
}
